import { mapEventType } from '../../helper/map-event-type';
export var eventType = function eventType(config) {
  return {
    'event:type': mapEventType(config.type)
  };
};